module.exports = __webpack_public_path__ + "static/media/lv-lv.6f0eb654.mp4";